export const CONTEST_REQUEST = 'CONTEST/CONTEST_REQUEST'
export const CONTEST_SUCCESS = 'CONTEST/CONTEST_SUCCESS'
export const CONTEST_ERROR = 'CONTEST/CONTEST_ERROR'

export const DRAFT_REQUEST = 'CONTEST/DRAFT_REQUEST'
export const DRAFT_SUCCESS = 'CONTEST/DRAFT_SUCCESS'
export const DRAFT_ERROR = 'CONTEST/DRAFT_ERROR'
